var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFalseRed(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "12px",
    height: "12px",
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "A445BF84-E67A-479C-A9E3-E1D5E11E0525") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grower---Overlay-Right-Drawer---Documets",
    transform: "translate(-1381.000000, -755.000000)",
    fill: "#F5222D"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1387,755 C1383.68594,755 1381,757.685938 1381,761 C1381,764.314062 1383.68594,767 1387,767 C1390.31406,767 1393,764.314062 1393,761 C1393,757.685938 1390.31406,755 1387,755 L1387,755 Z M1389.88434,763.331133 C1390.03513,763.482236 1390.03753,763.728388 1389.89032,763.883147 L1389.89032,763.883147 C1389.74191,764.036687 1389.50016,764.039124 1389.34816,763.88924 L1387,761.545921 L1384.65184,763.888021 C1384.50104,764.039124 1384.25809,764.036687 1384.10968,763.881928 L1384.10968,763.881928 C1383.96127,763.728388 1383.96367,763.481017 1384.11566,763.329914 L1386.45305,761 L1384.11566,758.668867 C1383.96487,758.517764 1383.96247,758.271612 1384.10968,758.116853 L1384.10968,758.116853 C1384.25809,757.963313 1384.49984,757.960876 1384.65184,758.11076 L1387,760.454079 L1389.34816,758.111979 C1389.49896,757.960876 1389.74191,757.963313 1389.89032,758.118072 L1389.89032,758.118072 C1390.03873,758.271612 1390.03633,758.518983 1389.88434,758.670086 L1387.54695,761 L1389.88434,763.331133 L1389.88434,763.331133 Z",
    id: "Shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFalseRed);
export default __webpack_public_path__ + "static/media/falseRed.cc21e0a5e11faa637cc325022ddc4a21.svg";
export { ForwardRef as ReactComponent };